import { ApiResponse } from "../schemas/apiResponseSchema";
import apiClient from "../clients/apiClient";
import { Schemas } from "../types/api-types";

export type SystemMenuResponse = Schemas['SystemMenuResponse'];

export interface SystemMenuWithChildrenResponse extends SystemMenuResponse {
    children?: SystemMenuWithChildrenResponse[];
}

export async function getAllSystemMenus(): Promise<SystemMenuResponse[]> {
    try {
        const response: ApiResponse<SystemMenuResponse[]> = (await apiClient.get('/menus/all')).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Fetching system menus failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function getParentSystemMenus(): Promise<SystemMenuResponse[]> {
    try {
        const response: ApiResponse<SystemMenuResponse[]> = (await apiClient.get('/menus/parent')).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Fetching parent menus failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function getSystemMenuHierarchy(): Promise<SystemMenuWithChildrenResponse[]> {
    try {
        const response: ApiResponse<SystemMenuWithChildrenResponse[]> = (await apiClient.get('/menus/hierarchy')).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Fetching menu hierarchy failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function getSystemMenuById(menuId: number): Promise<SystemMenuResponse> {
    try {
        const response: ApiResponse<SystemMenuResponse> = (await apiClient.get(`/menus/${menuId}`)).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Fetching menu failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function getSystemMenuByUrl(url: string): Promise<SystemMenuResponse> {
    try {
        const response: ApiResponse<SystemMenuResponse> = (await apiClient.get(`/menus/by-url/${url}`)).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Fetching menu failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function getSystemMenuByComponent(component: string): Promise<SystemMenuResponse> {
    try {
        const response: ApiResponse<SystemMenuResponse> = (await apiClient.get(`/menus/by-component/${component}`)).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Fetching menu failed');
        }
        throw new Error('network error, please contact support team');
    }
}

export async function getSystemMenuChildren(parentId: number): Promise<SystemMenuResponse[]> {
    try {
        const response: ApiResponse<SystemMenuResponse[]> = (await apiClient.get(`/menus/children/${parentId}`)).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Fetching child menus failed');
        }
        throw new Error('network error, please contact support team');
    }
}
